export default {
  "wt-unselect-option-hint": "_wt-unselect-option-hint_1njfosh_1",
  "wt-unselect-option-hint_size_m": "_wt-unselect-option-hint_size_m_1njfosh_15",
  "wt-unselect-option-hint_size_s": "_wt-unselect-option-hint_size_s_1njfosh_19",
  "wt-unselect-option-hint_theme_light": "_wt-unselect-option-hint_theme_light_1njfosh_23",
  "wt-unselect-option-hint_theme_dark": "_wt-unselect-option-hint_theme_dark_1njfosh_28"
};